export const DEFAULT_CATEGORY = "all";
export const DEFAULT_PDP_CATEGORY = "cameras";
export const DEFAULT_CATEGORY_SORT = "recommended";
export const DEFAULT_KITS_CATEGORY = "kits";

export const NAVIGATION_ITEM_TYPE = "navigationItem";
export const NAVIGATION_GROUP_TYPE = "navigationGroup";

export const SHOP_SEARCH_PARAM = "search";
export const SHOP_SORT_PARAM = "sort";
export const SHOP_CATEGORY_PARAM = "category";
/** Query param for rich text “interactive action” slide-out on /shop */
export const SHOP_DRAWER_PARAM = "drawer";

/** sessionStorage: refocus sort `<select>` after `redirect()` from shop filters */
export const SHOP_SORT_FOCUS_STORAGE_KEY = "shop-sort-focus";

export const PDP_FORM_SEARCH = "search";
export const PDP_FORM_CATEGORY = "category";
export const PDP_FORM_ACCESSORIES_SORT = "sort-accessories";

export const RESULTS_VIRTUAL_CATEGORY_ID = "quiz-results";
export const RESULTS_VIRTUAL_CATEGORY_LABEL = "Results";

export type ShopSortValue = "recommended" | "low-to-high" | "high-to-low";

export const SEARCH_DEBOUNCE_MS = 400;

export const SORT_OPTIONS: { value: ShopSortValue; label: string }[] = [
  { value: "recommended", label: "Recommended" },
  { value: "low-to-high", label: "Price: Low to High" },
  { value: "high-to-low", label: "Price: High to Low" },
];

export const MONITORING_PLAN_SEARCH_PARAM = "monitoringPlan";

export const BMO_PRODUCT_ID = "build-my-system";

export const SHOW_SUMMARY_COOKIE = "show_cart_summary";
export const ECID_QUERY_PARAM = "ecid";
export const ECID_CAMPAIGN_COOKIE = "adt_campaign_data";
export const ECID_TRAFFIC_SOURCE_COOKIE = "adt_campaign_traffic_source_data";

export const DEFAULT_ABANDONED_CART_EVENT_KEY = "APIEvent-AbandonedCart_Prod";
export const DEFAULT_EMAIL_CAPTURE_EVENT_KEY = "APIEvent-Email_Capture";
export const DEFAULT_QUIZ_CAPTURE_EVENT_KEY = "APIEvent-FitQuiz_Capture";
export const DEFAULT_SAVE_CART_EVENT_KEY = "APIEvent-MKT_SavedCart_Prod";
export const PREFERRED_LANGUAGE = "en";

export const PRODUCT_TYPE_KIT = "kit";
export const PRODUCT_TYPE_CAMERA = "camera";
export const PRODUCT_TYPE_MONITORING = "monitoring";
export const PRODUCT_TYPE_ACCESSORY = "accessory";
